import { render, staticRenderFns } from "./BlockDispatch.vue?vue&type=template&id=4f50093c&scoped=true"
import script from "./BlockDispatch.vue?vue&type=script&lang=js"
export * from "./BlockDispatch.vue?vue&type=script&lang=js"
import style0 from "./BlockDispatch.vue?vue&type=style&index=0&id=4f50093c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f50093c",
  null
  
)

export default component.exports